<template>
  <div id="page-forms">
    <v-container fluid>
      <v-form
        v-model="form.valid"
        ref="preparationform"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >

          <v-flex
            lg6
            sm6
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"              
              chips              
              flat
              placeholder="Select only suggested Reference Document"
              :items="wikilists"
              v-model="form.referenceDocument"
              label="Reference Document"
              auto
              chips
              prepend-icon="attach_file"
              required
              item-text="name"
              item-value="name"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg1
            sm1
          ></v-flex>
          <v-flex
            lg5
            sm5
          >
            <p>
              <v-icon>graphic_eq</v-icon>&nbsp;&nbsp; Require Preparation
            </p>
            <v-radio-group
              v-model="form.requiredPreparation"
              row
            >
              <v-radio
                label="Yes"
                value="true"
              ></v-radio>
              <v-radio
                label="No"
                value="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex
            lg12
            sm12
          >

            <!-- <div class="d-flex my-1"> -->
            <div id='Type of Preparation'>
              <input
                type="label"
                value="Type of Preparation"
              >
            </div>
            <!-- </div> -->

          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <!-- <div class="d-flex my-1"> -->
            <v-text-field
              label="Preparation Days"
              suffix="Days"
              type="number"
              prepend-icon="insert_invitation"
              v-model="form.preparationDays"
            ></v-text-field>
            <!-- </div> -->
          </v-flex>

          <v-flex
            lg4
            sm4
          >
            <v-menu
              :close-on-content-click="false"
              v-model="menuremainder"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="form.reminderby"
                label="Reminder By"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="form.reminderby"
                @input="menuremainder = false"
              ></v-date-picker>
            </v-menu>

          </v-flex>

        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>

export default {
  components: {

  },

  data: () => ({
    menuremainder: false,
    form: {
      valid: false,
      companyEventID: -1,
      companyID: null,
      deptOwner: null,
      loginUser: 'Arun',
      isLogin: 'yes-1',
      date: new Date().toISOString().substr(0, 10),
      eventTypeID: null,
      eventType: '',
      fullfilmentStatus: null,
      isEffectProdSchdule: null,
      authorityOrCompanyRequirement: '',
      name: '',
      notLaterDays: null,
      preparationDays: null,
      preparationTypeID: null,
      reminderby: null,
      repeatInfoID: null,
      requiredPreparation: null,
      standardFrequencyID: null,
      startDate: null,
      taskContent: null,
      taskDueDate: null,
      triggerDate: null,
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: null,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      referenceDocument: '',
    },
    wikilists: [
      { id: 1, name: 'Temperature Mapping - Report- Intermediate Room (Granule)' },
      { id: 2, name: 'Temperature Mapping - Report (Chiller) - TMP-18-02' },
      { id: 3, name: 'PQ - ZP33 Tablet Press Machine' },
      { id: 4, name: 'PQ - Kobelco Compressed Air System (KS45A)' },
    ],

  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {

  }
};
</script>






// WEBPACK FOOTER //
// src/pages/calendar/PPPreparation.vue